import { COMPANY_SAVE_SUCCESS, COMPANY_SAVE_FAILURE } from '../constants';
import { saveCompanyProfile } from '../../services/CompanyServices';

export const saveProfile = companyData => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    firebase
      .updateProfile({ ...companyData, signUpComplete: true })
      .then(() => {
        dispatch({ type: COMPANY_SAVE_SUCCESS, payload: { companyData } });
        saveCompanyInterests(firestore, companyData.interests);
      })
      .catch(err => {
        dispatch({ type: COMPANY_SAVE_FAILURE, err });
      });
  };
};

const saveCompanyInterests = (firestore, interests) => {
  if (interests && interests.length) {
    firestore
      .collection('tags')
      .doc('company')
      .get()
      .then(interestDoc => {
        if (interestDoc.exists) {
          interests.map(interest => {
            interestDoc.ref.update({
              interests: firestore.FieldValue.arrayUnion(interest)
            });
          });
        } else {
          firestore
            .collection('tags')
            .doc('company')
            .set({
              interests
            });
        }
      });
  }
};

export const updateProfile = companyData => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .updateProfile({ ...companyData })
      .then(() => {
        dispatch({ type: COMPANY_SAVE_SUCCESS, payload: { companyData } });
      })
      .catch(err => {
        dispatch({ type: COMPANY_SAVE_FAILURE, err });
      });
  };
};

export const saveProfilePictureUrl = profilePictureUrl => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .updateProfile({ profilePictureUrl })
      .then(() => {
        dispatch({
          type: COMPANY_SAVE_SUCCESS,
          payload: { profilePictureUrl }
        });
      })
      .catch(err => {
        dispatch({ type: COMPANY_SAVE_FAILURE, err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/companyActions.js